export interface KycSlice {
  kycPage: number;
  setKycPage: (page: number) => void;
}

export const createKycSlice = (set: any): KycSlice => ({
  kycPage: 1,
  setKycPage: (kycPage) => set({ kycPage }),
});
